<template>
  <div class="register">
    <div class="title">创建您的个人账户，获取更多专属咨询</div>
    <div class="desc">*为必填项</div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <div class="input-item">
        <el-form-item prop="username" class="item-left">
          <el-input class="verify-input" v-model.trim="ruleForm.username" maxlength="30" placeholder="*姓名"></el-input>
        </el-form-item>
        <el-form-item prop="sex" class="item-right">
          <el-select v-model="ruleForm.sex" placeholder="*称谓">
            <el-option label="先生" value="1"></el-option>
            <el-option label="女士" value="2"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="mobile" class="common-ipt">
          <el-input v-model.trim="ruleForm.mobile" :readonly="mobileReadonly" minlength="11" maxlength="11"
            placeholder="*请输入您的手机号"></el-input>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="imgCode" class="item-left">
          <el-input v-model.trim="ruleForm.imgCode" class="verify-input" placeholder="*请输入图形验证码"></el-input>
        </el-form-item>
        <el-form-item class="item-right">
          <img class="verify-pic" :src="captchaImg" alt @click="refreshImgCode" />
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="code" class="item-left">
          <el-input v-model.trim="ruleForm.code" class="verify-input" placeholder="*请输入手机验证码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="send-btn" :disabled="disableSendSMS" @click="sendSMS">发送验证码{{
            `${countdown ? "(" + countdown + "s)" : ""}`
          }}</el-button>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="password" class="common-ipt">
          <el-input type="password" v-model="ruleForm.password" minlength="8" maxlength="16"
            placeholder="*请输入您的密码"></el-input>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item prop="repassword" class="common-ipt">
          <el-input type="password" v-model="ruleForm.repassword" placeholder="*请确认您的密码"></el-input>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item class="common-ipt">
          <el-date-picker v-model="ruleForm.birth" type="date" value-format="yyyy-MM-dd" placeholder="请选择您的生日"
            :picker-options="birthPickerOptions"></el-date-picker>
        </el-form-item>
      </div>
      <div class="input-item">
        <el-form-item class="status" prop="userCheck">
          <i class="iconfont" @click="ruleForm.userCheck = !ruleForm.userCheck">{{ ruleForm.userCheck ? "&#xedaf;" :
            "&#xec58;" }}</i>
           <span
            @click="ruleForm.userCheck = !ruleForm.userCheck"
            :class="[ruleForm.userCheck ? 'selected' : '']"
          >
            我已仔细阅读并同意鬼塚虎
            <a
              :href="MemberShipRules" target="_blank">会员规则
            </a>和
            <router-link to="/cms/privacy-policy" target="_blank"
              >隐私政策</router-link>
          </span>
        </el-form-item>
      </div>
      <el-button class="login-btn" :disabled="disableSubmit" @click="submitForm('ruleForm')">注册</el-button>
      <div class="has-account">
        已有账号，
        <router-link :to="{ path: 'Login' }">
          <span>立即登录</span>
        </router-link>
      </div>
    </el-form>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import { captureManualError } from '@/sentry/index'

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/.test(value)) {
        callback(new Error("密码长度为8~16个字符且包含大小写字母、数字各一个"));
      } else {
        callback();
      }
    };
    var validateRepass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    var validateUsercheck = (rule, value, callback) => {
      if (value === false) {
        callback(new Error("请阅读安全隐私政策"));
      } else {
        callback();
      }
    };
    return {
      authCode: "",
      mobileReadonly: false,
      captchaImgSrc: api[types.CAPTCHA](),
      now: Date.now(),
      countdown: 0,
      ruleForm: {
        username: "",
        sex: "", // 1: 男, 2: 女
        mobile: "",
        imgCode: "",
        code: "",
        password: "",
        repassword: "",
        userCheck: false,
        birth: "",
      },
      rules: {
        username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择称谓", trigger: "change" }],
        mobile: [
          {
            validator(fieldRule, value, callback) {
              if (!value) {
                callback(new Error("请输入手机号码"));
              } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("请输入正确的手机号码"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        imgCode: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        repassword: [{ validator: validateRepass, trigger: "blur" }],
        userCheck: [{ validator: validateUsercheck, trigger: "blur" }],
      },
      birthPickerOptions: {
        disabledDate(time) {
          // 注册页，个人中心信息编辑页，生日字段输入做限制:最低年龄为14周岁
          const earliestAllowedDate = new Date();
          earliestAllowedDate.setFullYear(earliestAllowedDate.getFullYear() - 14);
          return time.getTime() > earliestAllowedDate.getTime();
        }
      }
    };
  },
  created() {
    let { authCode, mobile } = this.$route.query;
    if (authCode && mobile) {
      this.authCode = authCode;
      this.ruleForm.mobile = mobile;
      this.mobileReadonly = true;
    }
  },
  methods: {
    // 刷新图形验证码
    refreshImgCode() {
      this.now = Date.now();
    },
    // 发送手机验证码短信
    sendSMS() {
      api[types.SEND_SMS]({
        mobile: this.ruleForm.mobile,
        imgCode: this.ruleForm.imgCode,
        type: "register",
      })
        .then((res) => {
          if (res?.code == 1) {
            this.runCountdown(60, (time) => {
              this.countdown = time;
            });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err)
        });
    },
    runCountdown(times, callback) {
      if (isNaN(times)) callback("倒计时定时器时间设置错误");
      callback(times);
      let timer = setInterval(() => {
        --times;
        callback(times, timer);
        if (times == 0) clearInterval(timer);
      }, 1000);
    },
    // 提交数据
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let newArgs = Object.assign({}, this.ruleForm);
          // 处理授权码：第三方授权绑定手机后完善用户信息
          if (this.authCode) newArgs.authCode = this.authCode;
          delete newArgs.imgCode;
          delete newArgs.repassword;
          delete newArgs.userCheck;
          api[types.REGISTER](newArgs)
            .then((res) => {
              if (res.data?.token) {
                this.$store.commit(types.LOGIN, res.data?.token);
                this.$store.dispatch(types.GET_PROFILE);
                //
                let returnUrl = this.$route.query?.returnUrl || "/";
                this.$router.push({ path: decodeURIComponent(returnUrl) });
                window.gtag("event", "account_registration", {
                  send_to: process.env?.VUE_APP_GA4,
                });
              } else {
                console.warn(res);
                this.$message({
                  message: res?.message,
                  type: "warning",
                });
              }
            })
            .catch((err) => {
              console.warn(err);
              captureManualError(err)
            });
        } else {
          return false;
        }
      });
    },
  },
  computed: {
    captchaImg() {
      return `${this.captchaImgSrc}?t=${this.now}`;
    },
    disableSendSMS() {
      if (this.countdown) return true;
      let { mobile, imgCode } = this.ruleForm;
      if (/^1[3456789]\d{9}$/.test(mobile) && imgCode) {
        return false;
      }
      return true;
    },
    disableSubmit() {
      let { username, sex, mobile, code, password, userCheck } = this.ruleForm;
      if (
        username &&
        sex &&
        /^1[3456789]\d{9}$/.test(mobile) &&
        code &&
        password &&
        userCheck
      ) {
        return false;
      }
      return true;
    },

    MemberShipRules() {
      return this.$store.state.commonConfig['MemberShip-Rules'] || 'https://statics.maiscrm.com/663c66976dc8b037dc6d0783/modules/retail/o_1j2lp85801ac61nup131sgtqp40/%E3%80%90FINAL%E3%80%91Onitsuka%20Tiger%20%E4%BC%9A%E5%91%98%E8%A7%84%E5%88%99V2025.8.15-%20%E5%85%A8%E6%B8%A0%E9%81%93.pdf';
    },
  },
};
</script>

<style lang="scss" scoped>
.item-left,
.common-ipt,
.el-date-editor {
  flex: 1;
}

.common-ipt .el-form-item__content .el-date-editor.el-input {
  width: 100%;
}

.item-left {
  margin-right: 10px;
}

.item-right {
  width: 135px;
}

.register {
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .desc {
    text-align: right;
    margin-bottom: 15px;
    color: #ae1723;
  }

  .input-item {
    display: flex;

    .verify-input {
      margin-right: 10px;
    }

    .verify-pic,
    .send-btn {
      width: 135px;
      height: 40px;
      cursor: pointer;
    }

    .send-btn {
      background: #fff;
      color: #999;
      border: 1px solid #ccc;
      font-size: 14px;
      border-radius: 2px;
      padding: 0;

      &[disabled] {
        color: #666;
        background: #e7e7e7;
        border: 1px solid #dcdfe6;
        cursor: not-allowed;
      }
    }
  }

  .iconfont {
    color: #ccc;
  }

  .status {
    text-align: left;

    & ::v-deep .el-form-item__content {
      cursor: pointer;

      span {
        &.selected {
          color: #000;
        }

        a {
          text-decoration: underline;
        }
      }
    }
  }

  .login-btn {
    width: 100%;
    height: 40px;
    color: #fff;
    background: #7f0019;
    font-size: 14px;

    &[disabled] {
      // color: #666;
      // background: #e7e7e7;
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  .has-account {
    font-size: 14px;
    color: #666;
    margin: 20px 0;

    span {
      color: #ae1723;
      text-decoration: underline;
    }
  }
}

.el-form,
.desc {
  width: 70%;
  margin: 0 auto;
}

@media only screen and (max-width: 800px) {
  .register {
    .title {
      font-size: 18px;
    }

    .input-item {
      display: flex;

      // .verify-input {
      //   min-width: 200px;
      //   width: 100%;
      // }
      ::v-deep .el-form-item {
        margin-right: 10px;
      }

      // .item-right {
      //   flex-grow: 1;
      // }
    }
  }

  .el-form,
  .desc {
    width: 100%;
    margin: 0 auto;
  }
}
</style>